// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table__header-wrapper tbody td[data-v-887641aa],[data-v-887641aa] .el-table__footer-wrapper tbody td{background-color:#fff}", ""]);
// Exports
module.exports = exports;
